import { render, staticRenderFns } from "./PeriodUpdatesIcon.vue?vue&type=template&id=4c18a46b&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c18a46b')) {
      api.createRecord('4c18a46b', component.options)
    } else {
      api.rerender('4c18a46b', component.options)
    }
    module.hot.accept("./PeriodUpdatesIcon.vue?vue&type=template&id=4c18a46b&functional=true&", function () {
      api.rerender('4c18a46b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/PeriodUpdatesIcon.vue"
export default component.exports